/* eslint-disable jira/filename-case */
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { UIAnalyticsEvent } from '@atlassian/jira-product-analytics-bridge';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import type { State, Props } from './SuggestedTopicState.types.tsx';
import { dismissTopic } from './dismissTopic.tsx';
import { fetchSuggestedTopics } from './FetchSuggestedTopicsFetchSuggestedTopics.tsx';
import { setPagination } from './setPagination.tsx';
import { fetchAiDraftPreviewContent } from './FetchAiDraftPreviewContentFetchAiDraftPreviewContent.tsx';
import { triggerArticleGenerationForTopics } from './triggerArticleGenerationForTopics.tsx';

export const actions: {
	readonly fetchSuggestedTopics: (
		projectId: number,
		analyticsEvent: UIAnalyticsEvent,
		activationId: string,
	) => ({ getState, setState }: StoreActionApi<State>) => Promise<void>;
	readonly setPagination: (
		currentPage: number,
	) => ({ getState, setState }: StoreActionApi<State>) => Promise<void>;
	readonly dismissTopic: (
		topicId: string,
	) => ({ getState, setState }: StoreActionApi<State>, props: Props) => Promise<void>;
	readonly fetchAiDraftPreviewContent: (
		topicId: string,
	) => ({ getState, setState }: StoreActionApi<State>, props: Props) => Promise<void>;
	readonly triggerArticleGenerationForTopics: (
		projectId: number,
		analyticsEvent: UIAnalyticsEvent,
		activationId: string,
	) => () => Promise<void>;
} = {
	fetchSuggestedTopics,
	setPagination,
	dismissTopic,
	fetchAiDraftPreviewContent,
	triggerArticleGenerationForTopics,
} as const;

export type Actions = typeof actions;
